import { COMPONENTS } from '../../../components/components.registry';
import { PartialsConfig } from '../../../models';

export const DEFAULT_PARTIALS_CONFIG: PartialsConfig = {
  components: {
    panel: COMPONENTS.PURE.DefaultPartials,
    partial: {
      header: null,
      panel: COMPONENTS.PURE.DefaultPartialResult,
      grid: COMPONENTS.PURE.DefaultGrid,
      result: COMPONENTS.SMART.ConfigurableResult,
      footer: null
    }
  },
  gridColumns: 10
};
